import React from 'react'
import styles from './styles.module.css'

function CompanyDetails({ record }) {
  // Helper function to render a formatted value or "N/A"
  const renderValue = value =>
    value !== undefined && value !== null ? (
      <p className={styles.valueCompanyDetails}>{value}</p>
    ) : (
      <p className={styles.naValue}>N/A</p>
    )

  // Helper function to render Open/Closed status
  const renderOpenClosed = isClosed =>
    isClosed === 'true' ? (
      <p className={styles.valueCompanyDetails}>Closed</p>
    ) : isClosed === 'false' ? (
      <p className={styles.valueCompanyDetails}>Open</p>
    ) : (
      <p className={styles.naValue}>N/A</p>
    )

  // Helper function to render a range (min - max) or "N/A"
  const renderRange = (min, max, formatter) =>
    min !== undefined && min !== null && max !== undefined && max !== null ? (
      <p className={styles.valueCompanyDetails}>
        {formatter(min)} - {formatter(max)}
      </p>
    ) : (
      <p className={styles.naValue}>N/A</p>
    )

  // Currency formatter for revenue
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  }).format

  return (
    <div className={styles.containerCompanyDetailsBoxes}>
      <div className={styles.companyDetailsBoxes}>
        <span className={styles.labelCompanyDetails}>Year incorporated</span>
        {renderValue(record?.yearIncorporated)}
      </div>

      <div className={styles.companyDetailsBoxes}>
        <span className={styles.labelCompanyDetails}>Year opened</span>
        {renderValue(record?.yearOpened)}
      </div>

      <div className={styles.companyDetailsBoxes}>
        <span className={styles.labelCompanyDetails}>Open/closed</span>
        {renderOpenClosed(record?.isClosed)}
      </div>

      <div className={styles.companyDetailsBoxes}>
        <span className={styles.labelCompanyDetails}>Revenue</span>
        {renderRange(record?.revenueMin, record?.revenueMax, currencyFormatter)}
      </div>

      <div className={styles.companyDetailsBoxes}>
        <span className={styles.labelCompanyDetails}>Employees</span>
        {renderRange(
          record?.numEmployeesMin,
          record?.numEmployeesMax,
          val => val
        )}
      </div>
    </div>
  )
}

export default CompanyDetails
